var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarteUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.662,
    height: 14.522,
    viewBox: "1446.588 43 17.662 14.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1463.885 45.009h-1.644v-1.644a.365.365 0 0 0-.365-.365h-.366a.365.365 0 0 0-.365.365v1.644h-1.644a.365.365 0 0 0-.365.365v.365c0 .202.164.366.365.366h1.644v1.643c0 .202.164.366.365.366h.366a.365.365 0 0 0 .365-.366v-1.643h1.644a.365.365 0 0 0 .365-.366v-.365a.365.365 0 0 0-.365-.365Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-plus"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.905 50.304a3.61 3.61 0 1 0 0-7.219 3.61 3.61 0 0 0 0 7.219Zm-1.289 1.353a5.027 5.027 0 0 0-5.028 5.028c0 .462.375.837.838.837h10.958a.838.838 0 0 0 .837-.837 5.027 5.027 0 0 0-5.028-5.028h-2.577Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "user-solid"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteUserIcon);
export default __webpack_public_path__ + "static/media/carteUserIcon.f3592a0ae5b2350b431e2a6af9171a83.svg";
export { ForwardRef as ReactComponent };